import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import EditUser from '../EditUser/EditUser';
import EditAdmin from '../EditAdmin/EditAdmin';
import actions from '../../../redux/actions';

const Config = (props) => {
    const {
        setAdminSelected,
        setProviderSelected,
        roleName,
        cleanSelectSelf,
    } = props;

    useEffect(() => {
        setProviderSelected(undefined);
        setAdminSelected(undefined);
        cleanSelectSelf();
        // eslint-disable-next-line
    }, []);

  return roleName === 'ADMIN' ? (
    <EditAdmin {...props} currentUser={true} />
  ) : (
    <EditUser {...props} currentUser={true} />
  );
};

const mapStateToProps = (state) => ({
    roleName: state.login.userInfo.role.name,
    adminSelected: state.home.adminSelected,
    providerSelected: state.home.providerSelected,
    setSelfState: state.home.setSelfState,
    userSelected: state.login.userInfo,
});

const mapDispatchToProps = (dispatch) => ({
    selectSelf: () => dispatch(actions.home.selectSelf()),
    setProviderSelected: (providerSelected) => dispatch(actions.home.setProviderSelected(providerSelected)),
    setAdminSelected: (adminSelected) => dispatch(actions.home.setAdminSelected(adminSelected)),
    cleanSelectSelf: () => dispatch(actions.home.cleanSelectSelf()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Config);
